<template>
    <div class="fees">
        <section class="home-cards">
        <h4>Fee Structure</h4>
        <hr class="hr">
        <div class="home-cards-main">
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/grid.svg" alt="bank details">
                </div>
                <div class="feature-title">
                <h5>2022</h5>
                </div>
                <div class="feature-detail">
                  <table>
                    <tr>
                        <th></th>
                        <th>NURSERY</th>
                        <th>PRIMARY</th>
                    </tr>
                    <tr>
                        <td>REGISTRATION</td>
                        <td>K200</td>
                        <td>K200</td>
                    </tr>
                    <tr>
                        <td>SCHOOL FEES</td>
                        <td>K3,100</td>
                        <td>K3,320</td>
                    </tr>
                    <tr>
                        <td>TRANSPORT (1-WAY) OPT</td>
                        <td>K1,000</td>
                        <td>K1,000</td>
                    </tr>
                    <tr>
                        <td>TRANSPORT (2-WAY) OPT</td>
                        <td>K1,500</td>
                        <td>K1,500</td>
                    </tr>
                    <tr>
                        <td>LUNCH OPT</td>
                        <td>K800</td>
                        <td>K800</td>
                    </tr>
                    </table>
                </div>

                <div class="feature-detail">
                  <table>
                    <tr>
                        <th>UNIFORMS</th>
                        <th></th>
                    </tr>
                    <tr>
                        <td>SKIRT</td>
                        <td>K180</td>
                    </tr>
                    <tr>
                        <td>TROUSERS</td>
                        <td>K180</td>
                    </tr>
                    <tr>
                        <td>JERSEY</td>
                        <td>K250</td>
                    </tr>
                    <tr>
                        <td>TIE</td>
                        <td>K50</td>
                    </tr>
                    <tr>
                        <td>SOCKS</td>
                        <td>K60</td>
                    </tr>
                    <tr>
                        <td>SHIRT</td>
                        <td>K170</td>
                    </tr>
                    <tr>
                        <td>HEAD SOCKS</td>
                        <td>K50</td>
                    </tr>
                    <tr>
                        <td>SCARF</td>
                        <td>K60</td>
                    </tr>
                    <tr>
                        <td>GLOVES</td>
                        <td>K45</td>
                    </tr>
                    <tr>
                        <td>TRACK SUIT</td>
                        <td>K300</td>
                    </tr>
                    </table>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'Fees',
  components: { }
}
</script>

<style>
.fees .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.fees .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.fees .home-cards .home-cards-main {
  padding: 1em;
  max-width: 600px;
  margin: 0 auto;
}
.fees .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.fees .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.fees .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.fees .feature p {
  color: var(--inspire-charcoal);
}
.fees .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.fees .feature .feature-img.undraw {
  width: 85px;
  margin: 5px auto;
}
.fees .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
}
.fees .feature .feature-detail table {
  width: 100%;
}
</style>
